import boardExpensesByCategoryActions from '../actions/boardExpensesByCategoryActions';

const boardExpensesByCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case boardExpensesByCategoryActions.constants.set:
      return action.payload;

    default:
      return state;
  }
};

export default boardExpensesByCategoryReducer;
